<template>
  <div class="enrollmentResult">
    <!-- <el-page-header @back="goBack" content="录取通知书查询" title="返回重选">
    </el-page-header> -->
    <div class="selectform">
      <el-form ref="form" :model="form" label-width="120px">
          <el-form-item label="选择查询类别">
                <el-select                
                  v-model="chekedtype"
                  placeholder="查询类别"
                  :style="{width:'380px'}"
                >
                  <el-option
                    v-for="item in typeoptions"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="身份证/护照">
          <el-input v-model="form.id"></el-input>
        </el-form-item>
        <el-form-item>
        
          <el-button type="primary" @click="onSubmit">点击查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表头和表数据有相同唯一标识 v-model="row[tablelist.value]"  取到当前行的列字段tablelist.value与输入框进行双向绑定 -->
    <!-- 邮政快递轨迹 -->
    <!-- <div class="tableData">
      <el-table
        :data="tableData.data"
        v-loading="loading"
        style="width: 100%"
        ref="appTable"
        border
        empty-text="请输入查询条件"
        max-height="600"
      >
        <el-table-column
          v-for="(tablelist, dd) in tableData.tableTitle"
          :label="tablelist.label"
          :prop="tablelist.value"
          :key="tablelist.value"
        >
          <template slot-scope="scope">
              <div v-if="scope.column.property=='emsno'">
                  <a target="_black" :href="'https://www.kuaidi100.com/all/ems.shtml?mscomnu='+scope.row[scope.column.property]">{{scope.row[scope.column.property]}}</a>
              </div>
              <div v-else>
            {{ scope.row[scope.column.property] }}

              </div>
          </template>
        </el-table-column>
      </el-table>
    </div> -->
    <!-- <div class="result" v-loading="loading">
      <template v-if="show">
        <el-alert title="未查询到数据!" type="warning" :closable="false">
        </el-alert>
      </template>
      <ul>
        <template>
          <li v-for="title in tableData.tableTitle">
            {{ title.label }}:

            <div>{{ tableData.data[0][title.value] }}</div>
          </li>
        </template>
      </ul>
    </div> -->
      <div class="lqtzs" v-if="show">
    <transition name="fade">

        <div class="lqtzsMian" v-if="transitionshow">
          <div class="closelqtzsYear" @click="show = transitionshow = false">
            <i class="el-icon-close"></i>
          </div>
          <div class="lqtzsYear">
            {{ year }}
          </div>
          <table>
            <template v-for="title in tableData.tableTitle">
              <tr v-if="title.value != 'year'">
                
                <template v-if="title.value == 'emsno'">
                  <td> {{ title.label }}:</td>
                  <td> <div>
                    <!-- https://www.kuaidi100.com/all/ems.shtml?mscomnu= -->
                      <a
                      :style="{ color: '#8c1f24' }"
                      target="_black"
                      :href="
                        'http://yjcx.chinapost.com.cn/qps/yjcx'"
                    >
                      {{ tableData.data[0][title.value] }}
                    </a> </div></td>
                 
                  
                </template>

                <template v-else>
                  <td>   {{ title.label }}:</td>
                  <td> <div> {{ tableData.data[0][title.value] }}</div> </td>
                
                 
                </template>
              </tr>
            </template>
          </table>
        </div>
    </transition>

      </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        name: "",
        id: "",
      },
      title: "",
      tableData: [],
      loading: false,
      show: false,
      transitionshow: false,
      year: "",
      chekedtype:"",
        typeoptions: [
        { key: 0, value: "本专科生" },
        { key: 1, value: "硕士研究生" },
        { key: 2, value: "博士研究生" },
        { key: 3, value: "留学生" },
        { key: 4, value: "成人教育" },
      ],
    };
  },
  methods: {
    
    onSubmit() {
      this.loading = true;
      this.tableData = [];
      this.$http({
        method: "get",
        url: `/RegistrationMagt/api/Admission/AdultEduList`,
        params: {
          tabletype: this.chekedtype,
          name: this.form.name,
          idcard: this.form.id,
        },
      })
        .then((res) => {
          this.loading = false;

          console.log(res);
          if (res.data.msg == "error") {
            this.$allMethods.returnRrror(res.data.msg, res.data.response);
          } else{
            if (res.data.response.data.length != 0) {
              this.show = true;
              this.tableData = res.data.response;
              this.year = this.tableData.data[0].year;
              let that = this
              this.timer= setTimeout(function(){that.transitionshow = true}, 500);
            } else {
              this.$allMethods.returnRrror('error', '查询不到相关数据');
            }
          }
        })
        .catch((_) => {});
    },
    goBack() {
      this.$router.push("enrollmentResultIndex");
    },
  },
  created() {
    // switch (this.$store.state.QStype) {
    //   case 0:
    //     this.title = "本科生录取信息";
    //     break;
    //   case 1:
    //     this.title = "硕士录取信息";
    //     break;
    //   case 2:
    //     this.title = "博士录取信息";
    //     break;
    //   case 3:
    //     this.title = "留学生录取信息";
    //     break;
    //   case 4:
    //     this.title = "成人教育录取信息";
    //     break;
    // }
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
};
</script>
<style scoped>
.selectform {
  margin: 50px auto 20px;
  width: 500px;
  padding-right: 80px;
}

.lqtzsMian>table {
  font-weight: 700;
  list-style: none;
  font-size: 17px;
  margin: auto;
  width: 500px;
  padding-top: 60px;
  padding-left: 0px;
  text-align: left;
  overflow: auto;
  color: #8c1f24;
}
.lqtzsMian>table>tr>td>div {
  /* text-decoration: underline; */
  font-weight: 500;
  /* float: right; */
 
  color: #663030;
}
table>tr  {
  /* text-decoration: underline; */
  /* color: #409EFF; */
  margin-bottom: 14px;
  border-bottom: 1px solid #663030;
}
td{
   border-bottom: 1px dashed #bb656545;
height:30px;
min-width: 160px;
}
.lqtzs {
  height: 100vh;
  width: 100%;
  position: fixed;
  background: #00000066;
  z-index: 100;
  top: 0px;
  left: 0px;
}
.lqtzsMian {
  width: 1300px;
  height: 720px;
  margin: 70px auto;
  background: url("../assets/lqtzs4.png") no-repeat bottom;
  background-size: 100% auto;
}
.lqtzsYear {
  position: relative;
  font-size: 16px;
  font-weight: 700;
  color: #8c1f24;
  top: 34px;
}
.closelqtzsYear {
  position: relative;
  left: 1100px;
  /* top: 90px; */
  color: white;
  font-size: 30px;
  line-height: 40px;
  background: #00000030;
  height: 40px;
  width: 40px;
  cursor: pointer;
}
.closelqtzsYear :hover {
  -webkit-animation: rotation 0.2s linear;
}

@-webkit-keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(90deg);
  }
}


.fade-enter-active {
  animation: bounce-in .5s;
}
.fade-leave-active {
  animation: bounce-in .5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}

.enrollmentResult{
    width: 1200px;
    margin: auto;
}
</style>